import { get, set, del } from 'idb-keyval';
import {
	PersistedClient,
	Persister
} from '@tanstack/react-query-persist-client'
import { storageErrorTracker } from '../services/storage/StorageErrorTracker';

const noop = () => {};

/**
 * Creates an Indexed DB persister
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
function createIDBPersister( idbValidKey: IDBValidKey = 'reactQuery' ) {
	return {
		persistClient: async ( client: PersistedClient ) => {
			await storageErrorTracker.wrapIndexedDBOperation(
				() => set( idbValidKey, client ),
				'reactQuery',
				'write'
			).catch( noop );
		},
		restoreClient: async () => storageErrorTracker.wrapIndexedDBOperation(
			() => get<PersistedClient>( idbValidKey ),
			'reactQuery',
			'read'
		).catch( noop ),
		removeClient: async () => {
			await storageErrorTracker.wrapIndexedDBOperation(
				() => del( idbValidKey ),
				'reactQuery',
				'delete'
			).catch( noop );
		}
	} as Persister
}

export default createIDBPersister;
